import {SubscriptionMessagesSvc} from './SubscriptionMessagesSvc';

class SubscriptionMessages implements ng.IComponentController {
    constructor(public subscriptionMessageSvc: SubscriptionMessagesSvc) {
    }
}

angular.module('animatronApp.SubscriptionMessages', [])
    .component('subscriptionMessages', {
        controller: SubscriptionMessages,
        templateUrl: require('settings/subscription/messages/subscription-messages.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/messages/SubscriptionMessages.ts